/**
 * The script that runs in the frontend for this block.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import { Swiper } from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

export function initSlider() {
	const carousels = document.querySelectorAll(
		".content-slider.swiper-container",
	);

	carousels.forEach((carousel) => {
		if (carousel.classList.contains("swiper-initialized")) return;

		const wrapper = carousel.querySelector(".swiper-wrapper");

		document.querySelectorAll(".swiper-wrapper > *").forEach((el) => {
			el.classList.add("swiper-slide");
		});

		const slides = parseInt(carousel.dataset.slides || 1, 10);
		const slidesMobile = parseInt(carousel.dataset.slidesMobile || 1, 10);
		const slidesTablet = parseInt(carousel.dataset.slidesTablet || 2, 10);
		const spaceBetween = parseInt(carousel.dataset.spaceBetween) || 30;
		const isAutoplayEnabled = carousel.dataset.autoplay === "true";
		const speed = parseInt(carousel.dataset.speed || 500, 10);
		const showPagination = carousel.dataset.pagination === "true";

		const swiperConfig = {
			loop: true,
			speed,
			slidesPerView: slides,
			spaceBetween: spaceBetween,
			modules: [Autoplay, Navigation, Pagination],
			breakpoints: {
				320: {
					slidesPerView: slidesMobile,
				},
				768: {
					slidesPerView: slidesTablet,
				},
				1024: {
					slidesPerView: slides,
				},
			},
			navigation: {
				nextEl: carousel.querySelector(".swiper-button-next"),
				prevEl: carousel.querySelector(".swiper-button-prev"),
			},
			autoplay: isAutoplayEnabled
				? {
						delay: speed,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
				  }
				: false,
		};

		if (showPagination) {
			swiperConfig.pagination = {
				el: carousel.querySelector(".swiper-pagination"),
				clickable: true,
			};
		}

		new Swiper(carousel, swiperConfig);
	});
}

document.addEventListener("DOMContentLoaded", () => {
	initSlider();
});
